export default {
    meta: {
        title: '加入公司',
        isShowHeader: false,
    },
};
